import _export from "../internals/export";
import _fails from "../internals/fails";
import _isObject from "../internals/is-object";
import _classofRaw from "../internals/classof-raw";
import _arrayBufferNonExtensible from "../internals/array-buffer-non-extensible";
var $ = _export;
var fails = _fails;
var isObject = _isObject;
var classof = _classofRaw;
var ARRAY_BUFFER_NON_EXTENSIBLE = _arrayBufferNonExtensible;

// eslint-disable-next-line es/no-object-issealed -- safe
var $isSealed = Object.isSealed;
var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () {
  $isSealed(1);
});

// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$({
  target: "Object",
  stat: true,
  forced: FORCED
}, {
  isSealed: function isSealed(it) {
    if (!isObject(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === "ArrayBuffer") return true;
    return $isSealed ? $isSealed(it) : false;
  }
});
export default {};